import React from 'react';
import PropTypes from 'prop-types';
import Typography from "../../../../components/Typography";
import {confirm_password_message, required_message} from "../../../../utils/validations";
import {MuiTextField} from "../../../../components/MuiComponents/FormInputs";
import {useForm} from "react-hook-form";
import Button from "../../../../components/Button";
import SuccessIcon from "../../../../components/SuccessOrFailedModal/SuccessIcon";
import {useMutation} from "react-query";
import {setPassword} from "../../../../api/mutations/auth";
import {useDispatch, useSelector} from "react-redux";
import MainLoader from "../../../../components/Loader/MainLoader";
import {password as passwordValidation} from "../../../../utils/validations";
import {setFormError} from "../../../../redux/reducers/auth";
import PasswordPolicy from "./PasswordPolicy";

const PasswordForm = ({submit}) => {
    const {register, handleSubmit, formState: {errors, isValid}, watch, trigger} = useForm({mode:'onChange'})
    let mutation = useMutation(setPassword)
    let tokenFromOtp = useSelector(state => state.auth.tokenFromOtp)
    const dispatch = useDispatch()
    const formErrors = useSelector(state => state.auth.formErrors)
    const onSubmit = async (data) => {
        try {
            data.token = tokenFromOtp;
            await mutation.mutateAsync(data)
            submit("password")
        } catch (e) {
            dispatch(setFormError({
                password_form: e?.response?.data?.message || "error"
            }))
        }
    }
    const password = watch("password")
    let disabled = Object.keys(errors).length > 0 || !isValid || formErrors?.password_form?.length > 0

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                {mutation.isLoading && <MainLoader/>}
                <SuccessIcon/>
                <Typography variant={"h4"} className={"text-primary-800 pb-2.5"}>Code verification
                    successful</Typography>
                <Typography variant={"body1"} className={"px-4"}>Please proceed by setting a new password for your
                    account</Typography>
                <MuiTextField label={"Your Password"}
                              InputProps={{...register("password", {required: required_message, ...passwordValidation})}}
                              error={Boolean(errors?.password)}
                              type={"password"}
                              onKeyUp={() => {
                                  dispatch(setFormError({ password_form : null }))
                                  trigger(["password", "confirm_password"])
                              }}
                />
                <MuiTextField label={"Confirm Password"}
                              InputProps={{
                                  ...register("confirm_password", {
                                      required: required_message,
                                      validate: value => {
                                          return value === password ? true : confirm_password_message
                                      }
                                  })
                              }}
                              error={Boolean(errors?.confirm_password)}
                              helperText={errors?.confirm_password?.message}
                              type={"password"}
                              onKeyUp={() => {
                                  dispatch(setFormError({ password_form : null}))
                                  trigger(["password", "confirm_password"])
                              }}
                />               
                <Typography className={"text-functional-red mt-1"}>{formErrors?.password_form}</Typography>
                <PasswordPolicy passwordFromForm={password}/>
                <Button disabled={disabled} className={"mt-4"}>Continue</Button>
            </form>
        </div>
    );
};

PasswordForm.propTypes = {
    submit: PropTypes.func.isRequired
};

export default PasswordForm;
